<template>
  <v-container container--fluid>
    <v-layout class="main-content-wrapper" column>
      <v-flex>
        <v-toolbar flat color="transparent">
          <v-btn icon class="mr-4 ml-0" @click="toggleSidebar">
            <v-skeleton-loader
              v-if="fetchingUserData || !currentWorkspaceId"
              type="avatar"
              height="40"
              width="48"
            >
            </v-skeleton-loader>
            <workspace-avatar
              v-else
              size="40"
              color="red lighten-3"
              :workspace="currentWorkspace"
            ></workspace-avatar>
          </v-btn>
          <div>
            <v-btn
              text
              active-class="active"
              exact
              :to="{ name: 'dashboard', params: { workspaceId: currentWorkspaceId } }"
              >My Dashboard</v-btn
            >
            <v-btn
              text
              active-class="active"
              :to="{ name: 'contexts', params: { workspaceId: currentWorkspaceId } }"
              >Contexts</v-btn
            >
            <v-btn
              text
              active-class="active"
              :to="{ name: 'resources', params: { workspaceId: currentWorkspaceId } }"
              >Resources</v-btn
            >
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="
              createNewContextHandler({
                workspaceId: currentWorkspaceId,
                parentFolderId: undefined
              })
            "
            ><v-icon class="mr-2">add</v-icon> New Context</v-btn
          >
          <v-menu v-model="importResourceModal" :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text color="primary">
                IMPORT RESOURCE
              </v-btn>
            </template>
            <add-resource-widget @created="importResourceModal = false"></add-resource-widget>
          </v-menu>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 style="position: relative;">
        <router-view @newContext="createNewContextHandler($event)"></router-view>
      </v-flex>
    </v-layout>
    <v-dialog :value="creatingContext" width="300" persistent>
      <v-card>
        <v-card-title class="d-flex justify-center">
          Building Your Context
        </v-card-title>
        <v-card-text class="d-flex justify-center">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import WorkspaceAvatar from '@/components/WorkspaceAvatar';
import AddResourceWidget from '@/components/Resources/AddResourceWidget';

export default {
  props: ['workspaceId'],
  components: { WorkspaceAvatar, AddResourceWidget },
  created() {
    console.log(this);
  },
  mounted() {},

  data() {
    return {
      importResourceModal: false,
      creatingContext: false
    };
  },
  computed: {
    ...mapState('userWorkspaceLite', ['userWorkspaceLiteData']),
    ...mapState('workspaces', ['currentWorkspaceId']),
    ...mapState('auth', ['fetchingUserData']),
    ...mapGetters('workspaces', ['currentWorkspace'])
  },
  methods: {
    ...mapMutations('workspaces', ['setWorkspaceId']),
    ...mapActions('context', ['createNewContext']),
    ...mapMutations('components/explorerSidebar', ['toggleSidebar']),
    ...mapMutations('views/newContext', ['SET_NEWCONTEXT_STATE']),
    async createNewContextHandler(options) {
      try {
        this.SET_NEWCONTEXT_STATE({ key: 'setup', value: options });
        // this.creatingContext = true;
        // const id = await this.createNewContext(options);
        //  make sure the parent folder is open
        // if (options.parentFolderId && !this.open.includes(options.parentFolderId)) {
        //   this.open.push(options.parentFolderId);
        // }
        //this.creatingContext = false;
        //  Update route
        // console.log('update route');
        // this.$nextTick(() => {
        //   this.editFolderName = id;
        // });
        this.$nextTick(() => {
          this.$router.push({ name: 'newContext' });
        });
      } catch (e) {
        console.log(e);
        //this.creatingContext = false;
      }
    }
  }
};
</script>

<style>
.main-content-wrapper {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.2s ease right;
}
</style>
